export const Divider = () => (
  <div className="h-[0.8rem] w-full bg-brand-lightest-gray sm:hidden"></div>
);
